import axios from 'axios';

async function isAuthenticated() {
    const response = await axios.get('/auth');
    return response.data;
}

export default isAuthenticated;
